/*
 * @Descripttion: 常量设置
 * @Author: chenjinsheng
 * @Date: 2021-11-25 09:36:24
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-26 15:40:48
 */

const APPROVE_KEYS = {
    ALL: "-1",
    TODO_CHECK: "0",
    TODO_READ: "1",
    DONE_CHECK: "2",
    DONE_READ: "3",
    DEAL_FINISH: "4",
    WORK_COMMUNICATE: "5",
    HAS_APPLY: "6",
    DRAFT_PROCESS: "7",
    DONE_CHECK_PROCESS: "8",
    COLLECT_PROCESS: "9",
};

const HANDLE_TYPE_KEYS = new Map([
    ["待办", "待审"],
    ["待阅", "待阅"],
    ["已办", "已审"],
    ["已阅", "已阅"],
]);

const TASK_MAP_KEYS = new Map([
    ["-1", "全部"],
    ["0", "待审"],
    ["1", "待阅"],
    ["2", "已审"],
    ["3", "已阅"],
    ["4", "已处理"],
    ["5", "工作沟通"],
    ["6", "我发起"],
    ["7", "流程草稿"],
    ["8", "历史审批流程"],
    ["9", "收藏流程"],
]);

export { APPROVE_KEYS, TASK_MAP_KEYS, HANDLE_TYPE_KEYS };
